import React,{useState} from "react";
import { useForm } from "react-hook-form";
import { makeStyles } from '@material-ui/core/styles';
import { Grid,
  TextField,
  FormControl,
  Button,
  Typography,
  Select,
  InputLabel,
  MenuItem,
  } from "@material-ui/core";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { REQUIRED_MESSAGE } from "../../constants";

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: '20px 0px',
    width: '100%',
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(14px, -17px) scale(0.75)'
    }
  },
  labelInto: {
    marginLeft: 5
  },
  labelOutside: {
   
  },
}));
const schema = yup.object().shape({
    Denomination: yup.string().required().required(REQUIRED_MESSAGE),
    roleOfThePosition: yup.string().nullable().required(REQUIRED_MESSAGE),
    inmediateBoss: yup.string().nullable().required(REQUIRED_MESSAGE),
    supervisedCharges: yup.string().nullable().required(REQUIRED_MESSAGE),
    location: yup.string().nullable().required(REQUIRED_MESSAGE),
    missionOfPosition: yup.string().nullable().required(REQUIRED_MESSAGE),
    descriptionResponsibilities: yup.string().nullable().required(REQUIRED_MESSAGE),
    ProfileByCompetence: yup.string().nullable().required(REQUIRED_MESSAGE),
    corporateCompetencies: yup.string().nullable().required(REQUIRED_MESSAGE),
    leadershipCompetencies: yup.string().nullable().required(REQUIRED_MESSAGE),
    funtionalCompetencies: yup.string().nullable().required(REQUIRED_MESSAGE),
    inherentRisks: yup.string().nullable().required(REQUIRED_MESSAGE),
    
});

const defaultValues = {
  Denomination:   null,
  roleOfThePosition: null,
  inmediateBoss: null,
  supervisedCharges: null,
  location: null,
  missionOfPosition: null,
  descriptionResponsibilities: null,
  ProfileByCompetence: null,
  corporateCompetencies: null,
  leadershipCompetencies: null,
  funtionalCompetencies: null,
  inherentRisks: null,
};

const CreateProfile = () => {
  const classes = useStyles();

  const [age, setAge] = React.useState('');
  
    const [informationUser, setInformationUser] = useState({
      Denomination: '',
      roleOfThePosition: '',
      inmediateBoss: '',
      supervisedCharges: '',
      location: '',
      missionOfPosition: '',
      descriptionResponsibilities: '',
      ProfileByCompetence: '',
      corporateCompetencies: '',
      leadershipCompetencies: '',
      funtionalCompetencies: '',
      inherentRisks: '',
    });
  const { register, handleSubmit,  errors } = useForm({
    resolver: yupResolver(schema),
    defaultValues
  });

  const onSubmit = data => {
  }

  const handleChange = (event) => {
    setAge(event.target.value);
  };


  return (
      <form onSubmit={handleSubmit(onSubmit)} style={{ width: 'auto',
    
        marginTop: '20px',
        marginRight: '15px',
        marginLeft: '15px'
        }}>
        <Typography component='h1' variant='h4' style={{textAlign:'center'}}>
          Crear Perfil
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={4}>
          <FormControl fullWidth>
                <TextField
                    fullWidth
                    variant="outlined"
                    inputRef={register}
                    value={informationUser.Denomination}
                    label="Denominacion o Nombre"
                    name="Denomination"
                    margin="normal"
                    error={!!errors.hasOwnProperty("Denomination") && errors["Denomination"].message}
                    helperText={ errors.hasOwnProperty("Denomination") && errors["Denomination"].message}
                />
            </FormControl>
            <FormControl fullWidth>
                <TextField
                    fullWidth
                    variant="outlined"
                    inputRef={register}
                    label="Rol del Cargo"
                    name="roleOfThePosition"
                    margin="normal"
                    error={!!errors.hasOwnProperty("roleOfThePosition") && errors["roleOfThePosition"].message}
                    helperText={errors.hasOwnProperty("roleOfThePosition") && errors["roleOfThePosition"].message}
                />
            </FormControl>
            <FormControl fullWidth>
                <TextField
                    fullWidth
                    variant="outlined"
                    inputRef={register}
                    label="Compet. Funcionales Asistenciales"
                    name="funtionalCompetencies"
                    margin="normal"
                    error={!!errors.hasOwnProperty("funtionalCompetencies") && errors["funtionalCompetencies"].message}
                    helperText={errors.hasOwnProperty("funtionalCompetencies") && errors["funtionalCompetencies"].message}
                />
            </FormControl>
            <FormControl variant='outlined' className={classes.margin}>
      <InputLabel htmlFor="age-native-required" >Jefe Inmediato</InputLabel >
        <Select
          labelId="demo-customized-select-label"
          id="demo-customized-select"
          value={age}
          name="inmediateBoss"
          onChange={handleChange}
          error={!!errors.hasOwnProperty("inmediateBoss") && errors["inmediateBoss"].message}
          helperText={errors.hasOwnProperty("inmediateBoss") && errors["inmediateBoss"].message}
        >
          <MenuItem value="" >
            <em>None</em>
          </MenuItem>
          <MenuItem value={10}>Carlos</MenuItem>
          <MenuItem value={20}>Peñaranda</MenuItem>
          <MenuItem value={30}>Tocancio</MenuItem>
        </Select>
      </FormControl>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
      <FormControl fullWidth>
                <TextField
                    fullWidth
                    variant="outlined"
                    inputRef={register}
                    label="Mision Del Cargo"
                    name="missionOfPosition"
                    margin="normal"
                    error={!!errors.hasOwnProperty("missionOfPosition") && errors["missionOfPosition"].message}
                    helperText={errors.hasOwnProperty("missionOfPosition") && errors["missionOfPosition"].message}
                />
            </FormControl>
          <FormControl fullWidth>
                <TextField
                    fullWidth
                    variant="outlined"
                    inputRef={register}
                    label="Descripcion De Responsabilidades"
                    name="descriptionResponsibilities"
                    margin="normal"
                    error={!!errors.hasOwnProperty("descriptionResponsibilities") && errors["descriptionResponsibilities"].message}
                    helperText={errors.hasOwnProperty("descriptionResponsibilities") && errors["descriptionResponsibilities"].message}
                />
            </FormControl>
            <FormControl fullWidth>
                <TextField
                    fullWidth
                    variant="outlined"
                    inputRef={register}
                    label="Perfil por competencias"
                    name="ProfileByCompetence"
                    margin="normal"
                    error={!!errors.hasOwnProperty("ProfileByCompetence") && errors["ProfileByCompetence"].message}
                    helperText={errors.hasOwnProperty("ProfileByCompetence") && errors["ProfileByCompetence"].message}
                />
            </FormControl>
            <FormControl variant='outlined' className={classes.margin}>
      <InputLabel htmlFor="age-native-required" >Ubicacion</InputLabel >
        <Select
          labelId="demo-customized-select-label"
          id="demo-customized-select"
          name="location"
          value={age}
          onChange={handleChange}
          error={!!errors.hasOwnProperty("location") && errors["location"].message}
          helperText={errors.hasOwnProperty("location") && errors["location"].message}
        >
          <MenuItem value="" >
            <em>None</em>
          </MenuItem>
          <MenuItem value={10}>Medellin</MenuItem>
          <MenuItem value={20}>Cali</MenuItem>
          <MenuItem value={30}>Boota</MenuItem>
        </Select>
      </FormControl>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
         
          <FormControl fullWidth>
                <TextField
                    fullWidth
                    variant="outlined"
                    inputRef={register}
                    label="Riesgos Inherentes"
                    name="inherentRisks"
                    margin="normal"
                    error={!!errors.hasOwnProperty("inherentRisks") && errors["inherentRisks"].message}
                    helperText={errors.hasOwnProperty("inherentRisks") && errors["inherentRisks"].message}
                />
            </FormControl>
            <FormControl fullWidth>
                <TextField
                    fullWidth
                    variant="outlined"
                    inputRef={register}
                    label="Competencias Corporativas"
                    name="corporateCompetencies"
                    margin="normal"
                    error={!!errors.hasOwnProperty("corporateCompetencies") && errors["corporateCompetencies"].message}
                    helperText={errors.hasOwnProperty("corporateCompetencies") && errors["corporateCompetencies"].message}
                />
            </FormControl>
            <FormControl fullWidth>
                <TextField
                    fullWidth
                    variant="outlined"
                    inputRef={register}
                    label="Competencias De Liderazgo"
                    name="leadershipCompetencies"
                    margin="normal"
                    error={!!errors.hasOwnProperty("leadershipCompetencies") && errors["leadershipCompetencies"].message}
                    helperText={errors.hasOwnProperty("leadershipCompetencies") && errors["leadershipCompetencies"].message}
                />
            </FormControl>
            <FormControl variant='outlined' className={classes.margin}>
      <InputLabel htmlFor="age-native-required" >Cargos Bajo Su Supervision</InputLabel >
        <Select
          labelId="demo-customized-select-label"
          id="demo-customized-select"
          name="supervisedCharges"
          value={age}
          onChange={handleChange}
          error={!!errors.hasOwnProperty("supervisedCharges") && errors["supervisedCharges"].message}
          helperText={errors.hasOwnProperty("supervisedCharges") && errors["supervisedCharges"].message}
        >
          <MenuItem value="" >
            <em>None</em>
          </MenuItem>
          <MenuItem value={10}>Secretaria</MenuItem>
          <MenuItem value={20}>Medicinas</MenuItem>
          <MenuItem value={30}>Consultorios</MenuItem>
        </Select>
      </FormControl>
          </Grid>
        </Grid>
        <Grid container  spacing={3}>
          <Grid item xs={12} sm={3}>
            <Button
                  type="submit"
                  fullWidth
                  variant="contained" 
                  style={{paddingTop:'16px',paddingBottom: '13px',marginTop:'16px',textTransform: "none",
                  width: "100%",
                  background: '#0f70b7',
                  color: 'white',
                  marginBottom: '20px',
                  '&:hover': 
                  {color: '#0f70b7',
                    background: '#daa900'}}}
              >
                  ENVIAR
            </Button>
         </Grid>
        </Grid>
      </form>
    
  );
}


export default CreateProfile;